import {
  Authenticator,
  SignIn,
  SignedOutMessage,
  ConfirmSignUp,
  Loading,
  ForgotPassword,
  VerifyContact,
  AmplifyTheme,
  SignUp,
  RequireNewPassword,
} from "aws-amplify-react-native";
import HomeStack from "../routes/HomeStack";
import {
  Button,
  Image,
  ImageBackground,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
// import { ScrollView } from "react-native-gesture-handler";
import UserContextProvider from "../globalData/UserContext";
import CommunityContextProvider from "../globalData/ComunityContext";
import ComNavContextProvider from "../globalData/ComNavContext";
import { StatusBar } from "expo-status-bar";
import { useState } from "react";
import { globalStyles } from "../styles/globalStyles";
import Ionicons from "react-native-vector-icons/Ionicons";
import { Auth } from "aws-amplify";
import { I18n } from "aws-amplify";
import KeyBoardAvoidingWrapper from "./components/KeyboardAvoidingWrapper";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
import { GestureHandlerRootView } from "react-native-gesture-handler";

export default function WelcomeScreen() {
  const [authState, setAuthState] = useState("welcome");

  if (authState == "welcome")
    return (
      <ImageBackground
        source={require("../assets/welcomeBackground.png")}
        style={{ flex: 1 }}
      >
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
              marginBottom: 10,
              padding: 20,
            }}
          >
            <Image
              source={require("../assets/logo.png")}
              style={
                Platform.OS == "web"
                  ? { width: 400, height: 300 }
                  : { width: 250, height: 175 }
              }
            />
          </View>
          <Text style={styles.subtitle}>WELCOME TO</Text>
          <Text style={styles.title}>Uncaged!</Text>
          <Text
            style={{
              ...globalStyles.subtitleText,
              marginTop: -5,
              color: "#8a7269",
            }}
          >
            Free your book from their dusty shelves and give them a new purpose!
          </Text>
          <TouchableOpacity style={styles.buttonStyle}>
            <Text
              style={{
                ...styles.buttonText,
                paddingHorizontal: 50,
                paddingVertical: 15,
              }}
              onPress={() => {
                setAuthState("signIn");
              }}
            >
              LOGIN
            </Text>
          </TouchableOpacity>
          <View
            style={{
              marginTop: 10,
              backgroundColor: "#408f86",
              borderRadius: 25,
              padding: 10,
              margin: 10,
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                ...globalStyles.subtitleText,
                color: "white",
                fontSize: 17,
                marginTop: 0,
                fontFamily: "quicksand-bold",
              }}
            >
              Join now for a chance of a free Starbucks gift card!
            </Text>
          </View>
        </View>
        <View
          style={{
            height: 120,
            flexDirection: "row",
            justifyContent: "flex-end",
            marginHorizontal: 50,
            alignItems: "center",
          }}
        >
          {/* <TouchableOpacity style={{ flexDirection: "row" }}>
            <Text
              style={{
                fontFamily: "quicksand-bold",
                fontSize: 20,
                color: "#614d45",
              }}
              onPress={() => {
                setAuthState("signUp");
              }}
            >
              SIGN UP
            </Text>
            <Ionicons
              name={"chevron-forward-outline"}
              size={24}
              color={"#614d45"}
            />
          </TouchableOpacity> */}
        </View>
      </ImageBackground>
    );
  if (authState === "signedIn")
    return (
      // Calling Home Stack. The UserContextProvider is a global store to use User and Community Data across components
      <UserContextProvider>
        <CommunityContextProvider>
          <ComNavContextProvider>
            <HomeStack />
          </ComNavContextProvider>
        </CommunityContextProvider>
      </UserContextProvider>
    );

  let topImage = (
    <Image
      source={require("../assets/logo.png")}
      style={styles.imageStyle}
      resizeMode={"contain"}
    />
  );
  if (authState === "signUp") {
    topImage = (
      <Image
        source={require("../assets/banner.png")}
        style={{ marginTop: 10, marginLeft: 20 }}
      />
    );
  }
  //  Il8n changes certain keywords in order to allow translation (in this case, changes the
  // Username keyword to "email")
  I18n.setLanguage("en");
  const dict = {
    en: {
      Username: "Email",
      "Enter your username": "Enter your email",
    },
  };
  I18n.putVocabularies(dict);

  // note: safeareaprovider is required in order to get the screen to render on web
  // FUTURE CHANGE: change style of sign in screen so it looks more like discords
  return (
    <SafeAreaProvider>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <KeyBoardAvoidingWrapper>
          <StatusBar style="auto" />
          <View
            style={{
              flex: 1,
              backgroundColor: "#A48578",
              alignItems: "center",
            }}
          >
            {topImage}
            <Authenticator
              hideDefault={true}
              onStateChange={(authStateChange) => {
                setAuthState(authStateChange);
              }}
              theme={customTheme}
            >
              <SignUp signUpConfig={signUpConfig} />
              <SignIn />
              <SignedOutMessage />
              <ConfirmSignUp />
              <Loading />
              <ForgotPassword />
              <VerifyContact />
              <RequireNewPassword />
            </Authenticator>
          </View>
        </KeyBoardAvoidingWrapper>
      </GestureHandlerRootView>
    </SafeAreaProvider>
  );
}
const customTheme = {
  ...AmplifyTheme,
  container: {
    ...AmplifyTheme.container,
    backgroundColor: "#A48578",
  },
  button: {
    ...AmplifyTheme.button,
    backgroundColor: "#56494C",
    borderRadius: 50,
  },
  sectionHeaderText: {
    color: "#56494C",
    fontSize: 37,
    fontFamily: "fasthand",
    textAlign: "center",
  },
  buttonText: {
    fontFamily: "quicksand-bold",
    color: "#E2CFC2",
  },
  input: {
    padding: 20,
    borderWidth: 3,
    borderRadius: 30,
    borderColor: "#E2CFC2",
    color: "#D1D6DC",

    fontFamily: "quicksand-bold",
    fontSize: 16,
  },

  inputLabel: {
    marginBottom: 8,
    fontFamily: "quicksand-bold",
    color: "#56494C",
    fontSize: 15,
  },
  sectionFooterLink: {
    fontSize: 15,
    color: "white",
    fontFamily: "quicksand-bold",
    alignItems: "baseline",
    textAlign: "center",
    borderWidth: 2,
    borderRadius: 15,
    borderColor: "#E2CFC2",
    marginHorizontal: 10,
    padding: 5,
  },

  sectionFooter: {
    ...AmplifyTheme.sectionFooter,
    marginBottom: 30,
  },

  signedOutMessage: {
    color: "#A48578",
  },
  navButton: {
    marginLeft: 12,
    borderRadius: 4,
    color: "pink",
  },
  sectionFooterLinkDisabled: {
    fontSize: 15,
    color: "#b5ada8",
    fontFamily: "quicksand-bold",
    alignItems: "baseline",
    textAlign: "center",
    borderWidth: 2,
    borderRadius: 15,
    borderColor: "#b5ada8",
    marginHorizontal: 10,
    padding: 5,
  },

  buttonDisabled: {
    backgroundColor: "#9B928D",
    alignItems: "center",
    padding: 16,
    borderRadius: 20,
  },
  errorRowText: {
    marginLeft: 15,
    fontFamily: "quicksand-bold",
    color: "#e8c4b5",
    fontSize: 17,
  },
};

const signUpConfig = {
  header: "Uncaged Sign Up",
  hiddenDefaults: ["username"],
  hideAllDefaults: true,
  signUpFields: [
    {
      label: "email",
      key: "username",
      required: true,
      displayOrder: 1,
      type: "email",
      custom: false,
    },
    {
      label: "username",
      key: "name",
      required: true,
      displayOrder: 2,
      type: "string",
    },
    {
      label: "password (atleast 8 characters)",
      key: "password",
      required: true,
      displayOrder: 3,
      type: "password",
    },
  ],
};

const styles = StyleSheet.create({
  imageStyle: {
    width: 300,
    height: 300,
    marginTop: 50,
  },
  subtitle: {
    fontFamily: "quicksand-normal",
    fontSize: 35,
    letterSpacing: 10,
    color: "#A48578",
  },
  title: {
    fontFamily: "fasthand",
    fontSize: 60,
    letterSpacing: 5,
    marginTop: -20,
    color: "#492C1D",
  },
  buttonStyle: {
    marginTop: 20,
    backgroundColor: "#ccb3a7",
    borderRadius: 40,
  },
  buttonText: {
    fontFamily: "quicksand-bold",
    color: "white",
    fontSize: 20,
  },
});
